module.exports = __webpack_public_path__ + "static/img/2机械式拉伸旋转机构.4277f88c.jpg";